import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const bookingsApi = createApi({
  reducerPath: 'bookingsApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['bookings'],
  endpoints: (builder) => ({
    findByBookingId: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.bookingDetailController.findByBookingId}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getAllBookingDetailBySearchCriteria: builder.mutation({
      query(body) {
        return {
          url: spotFinder.bookingDetailController.getAllBookingDetailBySearchCriteria,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    saveBookingDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.bookingDetailController.saveBookingDetail,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateBookingDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.bookingDetailController.updateBookingDetail,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    approveCancelBookingByAdmin: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.bookingDetailController.approveCancelBookingByAdmin}${body.bookingId}/${body.customerId}/${body.parkingSpaceLocationId}/${body.serviceProviderId}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    approveCancelBookingByServiceProvider: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.bookingDetailController.approveCancelBookingByServiceProvider}${body.bookingId}/${body.customerId}/${body.parkingSpaceLocationId}/${body.serviceProviderId}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateActualTime: builder.mutation({
      query(body) {
        return {
          url: spotFinder.bookingDetailController.updateActualTime,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    resolveDispute: builder.mutation({
      query(body) {
        return {
          url: spotFinder.bookingDetailController.resolveDispute,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    completeBookingDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.bookingDetailController.completeBookingDetail,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindByBookingIdMutation,
  useGetAllBookingDetailBySearchCriteriaMutation,
  useSaveBookingDetailMutation,
  useUpdateBookingDetailMutation,
  useApproveCancelBookingByAdminMutation,
  useApproveCancelBookingByServiceProviderMutation,
  useUpdateActualTimeMutation,
  useResolveDisputeMutation,
  useCompleteBookingDetailMutation,
} = bookingsApi;
